import pick from 'lodash/pick';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import { Big9GetCombination as serializeSelections } from '../../../utils/Big9GetCombination';

//@see useGroupForm initialState
export function serializeGroup(
    group,
    userId,
    extId,
    selections = null,
    combinationPrice = null,
    combinationCount = null
) {
    return omitBy(
        {
            groupName: group.name,
            groupId: group.groupId || 0,
            avatarUrl: group.image,
            groupOwnerId: userId,
            sharePrice: Number(group.sharePrice),
            sharesLimit: Number(group.maxShares),
            numberOfBoughtShares: Number(group.shareNumber),
            deadlineTime: Number(group.deadline),
            public: group.isPublic,
            offeringId: extId,
            selections: selections ? serializeSelections(selections) : null,
            combinationPrice,
            combinationCount,
        },
        isNil
    );
}
export function serializeGroupData(group, groupId) {
    return {
        groupId,
        groupName: group.name,
        description: group.description || '',
        avatarUrl: group.avatarUrl || '',
        groupOwnerId: group.groupOwnerId,
        sharePrice: group.settings.sharePrice,
        sharesLimit: group.settings.sharesLimit,
        deadlineTime: group.settings.deadlineTime,
        public: group.publicGroup,
    };
}

// export function serializeSelections(selections) {
//     return Object.entries(selections).map(([legNumber, { marks }]) => {
//         const isWildcard = marks.some((m) => m === '*');
//         return { legNumber, marks: isWildcard ? '*' : marks.join('/') };
//     });
// }

export function serializePool({
    group,
    extId,
    userId,
    selections = [],
    combinationPrice,
    combinationCount,
}) {
    return {
        // some of the properties are the same for group and its pool
        ...pick(serializeGroup(group, userId), [
            'sharePrice',
            'sharesLimit',
            'deadlineTime',
            'groupId',
            'groupOwnerId',
        ]),
        numberOfBoughtShares: Number(group.shareNumber),
        offeringId: extId,
        mode: 'SIMPLE',
        selections: serializeSelections(selections),
        combinationPrice,
        combinationCount,
    };
}

export function serializeCoupon({
    poolId,
    extId,
    selections = [],
    combinationCount,
    combinationPrice,
}) {
    return {
        poolId,
        offeringId: extId,
        selections: serializeSelections(selections),
        combinationPrice,
        combinationCount,
        couponAmount: combinationPrice * combinationCount,
    };
}

/**
 * Adds ['X/U'] as default marks to canceled event(s) selections
 *
 * @TODO: Make EditCoupon component that uses clearCouponData and setCouponData not to remove previously added defaults
 *
 * @param {Array<Object>} selections
 *        Example: [ { nr: 1,  marks: [''] }, { nr: 2,  marks: ['1/O', '2/O'] }, ... ]
 * @param {Array<Number>} canceledEventNumbers
 *        Example: [1]
 * @return {Array<Object>}
 *        Example: [ { nr: 1,  marks: ['X/U'] }, { nr: 2,  marks: ['1/O', '2/O'] }, ... ]
 */
function addDefaultSelectionsForCanceledEvents(
    selections,
    canceledEventNumbers
) {
    return selections.map((s) => {
        return canceledEventNumbers.includes(s.nr)
            ? { ...s, marks: ['X/U'] }
            : s;
    });
}

export function serializeCouponForUpdate({
    poolId,
    extId,
    selections = [],
    combinationCount,
    combinationPrice,
    originalCoupon,
}) {
    const canceledEventNumbers = originalCoupon.selections
        .filter((s) => s.info.status === 'CANCELED')
        .map((s) => s.nr);

    return {
        poolId,
        offeringId: extId,
        selections: addDefaultSelectionsForCanceledEvents(
            serializeSelections(selections),
            canceledEventNumbers
        ),
        combinationPrice,
        combinationCount,
        couponAmount: combinationPrice * combinationCount,
    };
}
